var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Watch } from "vue-property-decorator";
import { get } from "lodash-es";
import { simActivationService } from "../services/sim-activation.service";
var SimActivator = /** @class */ (function (_super) {
    __extends(SimActivator, _super);
    function SimActivator() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = 'sim-activator';
        _this.simNumber = '';
        _this.status = 'welcome';
        _this.message = '';
        _this.phoneNumberText = '1300 759 637';
        return _this;
    }
    SimActivator.prototype.created = function () {
        if (window.hasOwnProperty('phone_number_option')) {
            this.phoneNumberText = window.phone_number_option;
        }
    };
    SimActivator.prototype.simNumberChanged = function () {
        this.simNumber = this.simNumber.toUpperCase();
    };
    SimActivator.prototype.onReset = function () {
        this.status = 'welcome';
        this.message = '';
    };
    SimActivator.prototype.onSubmit = function () {
        var _this = this;
        if (this.simNumber.length < 12) {
            return;
        }
        this.status = 'processing';
        simActivationService.activate(this.simNumber).then(function (response) {
            if (response.status !== 200 || get(response, 'data.status') !== 'ok') {
                _this.status = 'error';
                _this.message = get(response, 'data.error');
                return;
            }
            switch (get(response, 'data.activation.status')) {
                case 'PENDING':
                    _this.status = 'pending';
                    break;
                case 'ACTIVE':
                    _this.status = 'success';
                    break;
                default:
                    _this.status = 'error';
                    _this.message = 'SIM could not be activated at this time';
            }
        });
    };
    Object.defineProperty(SimActivator.prototype, "leftColumnSlot", {
        get: function () {
            return this.$slots['left-column'];
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        Watch('simNumber')
    ], SimActivator.prototype, "simNumberChanged", null);
    SimActivator = __decorate([
        Component
    ], SimActivator);
    return SimActivator;
}(Vue));
export default SimActivator;
